import { render } from "./DeleteUsers.vue?vue&type=template&id=423b0c51"
import script from "./DeleteUsers.vue?vue&type=script&lang=js"
export * from "./DeleteUsers.vue?vue&type=script&lang=js"

import "./DeleteUsers.vue?vue&type=style&index=0&id=423b0c51&lang=css"
import "./DeleteUsers.vue?vue&type=style&index=1&id=423b0c51&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__